import { ColDef, ICellRendererParams } from "ag-grid-community";
import { CheckboxRenderer } from "../../../../../controls/ag-grid/components/CheckboxRenderer";
import { GridButtonsV2 } from "../../../../../controls/buttons/GridButtonsV2";
import { CatalogMoldSize } from "../../../models/CatalogMoldSize";
import { useCatalogMoldSizeContext } from "../context/CatalogMoldSizeContext";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  setMoldSize: (mold: CatalogMoldSize) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
};

export const useTableData = ({
  setMoldSize,
  setShowModal,
  showContextMenu,
}: Props) => {
  const { state } = useCatalogMoldSizeContext();

  const rows: CatalogMoldSize[] =
    state.moldSizes?.map((moldSize: CatalogMoldSize) => ({
      ...moldSize,
    })) || [];

  const columnDefs: ColDef[] = [
    {
      field: "MoldSizeName",
      headerName: "Name",
      minWidth: 20,
      flex: 2,
      cellStyle: cellStyle,
    },
    {
      field: "Height",
      headerName: "Height",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "Width",
      headerName: "Width",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "Code",
      headerName: "Code",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "LbsPerInch",
      headerName: "Lbs Per Inch",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "MinSpeedLimit",
      headerName: "MinSpeedLimit",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "Enabled",
      headerName: "Enabled",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "-",
      cellRenderer: GridButtonsV2,
      cellRendererParams: (params: ICellRendererParams) => ({
        setData: setMoldSize,
        data: params.data as CatalogMoldSize,
        setShowModal: setShowModal,
        showContextMenu: () =>
          showContextMenu(event, params.data, "moldSizeContext"),
      }),
      wrapText: false,
      autoHeight: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      minWidth: 330,
      filter: false,
      autoHeaderHeight: true,
    },
  ];
  return { rows, columnDefs };
};
